import Layout from "@/layout/Layout.vue";
import { P } from "@/config/permissions";

const provisioningRoutes = {
    path: "/infra",
    name: "infra",
    component: Layout,
    alwaysShow: true,
    meta: {
        title: "Provisioning",
        icon: "mdi:cog-transfer-outline",
        permissions: [P.PROVISIONING.ASSETS_BROWSE],
        noCache: true
    },
    children: [
        {
            path: "",
            name: "provisioning-asset-list",
            meta: {
                title: "Assets",
                icon: "mdi:server-network",
                noCache: true,
                permissions: [P.PROVISIONING.ASSETS_BROWSE]
            },
            component: () => import("@/views/provisioning/ProvisioningAssetList.vue")
        },
        {
            path: ":id(\\d+)",
            name: "provisioning-asset-detail",
            meta: {
                title: "Détail asset",
                noCache: true,
                permissions: [P.PROVISIONING.ASSETS_BROWSE]
            },
            component: () => import("@/views/provisioning/ProvisioningAssetDetail.vue"),
            hidden: true
        },
        {
            path: "templates",
            name: "provisioning-templates",
            meta: {
                title: "Templates",
                icon: "mdi:file-document-multiple",
                noCache: true,
                permissions: [P.PROVISIONING.TEMPLATES_BROWSE]
            },
            component: () => import("@/views/provisioning/ProvisioningTemplates.vue")
        },
        {
            path: "secrets",
            name: "provisioning-secrets",
            meta: {
                title: "Secrets",
                icon: "mdi:key-variant",
                noCache: true,
                permissions: [P.PROVISIONING.SECRETS_BROWSE]
            },
            component: () => import("@/views/provisioning/ProvisioningSecrets.vue")
        },
        {
            path: "jobs",
            name: "provisioning-jobs",
            meta: {
                title: "Jobs",
                icon: "mdi:cog-play",
                noCache: true,
                permissions: [P.PROVISIONING.JOBS_BROWSE],
                // Pastille : mes notifications de composite en échec non lues.
                badgeKey: "provisioning"
            },
            component: () => import("@/views/provisioning/ProvisioningJobs.vue")
        },
        {
            path: "jobs/:id(\\d+)",
            name: "provisioning-job-detail",
            meta: {
                title: "Détail job",
                noCache: true,
                permissions: [P.PROVISIONING.JOBS_BROWSE]
            },
            component: () => import("@/views/provisioning/ProvisioningJobDetail.vue"),
            hidden: true
        }
    ]
};

export default provisioningRoutes;
